var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGallery = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.509,
    height: 16.279,
    viewBox: "0 0 18.509 16.279",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#666;stroke:#666;stroke-width:.5px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gallery",
    transform: "translate(.25 -26.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23793",
    transform: "translate(0 26.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M175.825 159.668a1.836 1.836 0 1 0 1.836 1.836 1.836 1.836 0 0 0-1.836-1.836zm0 2.8a.962.962 0 1 1 0-1.924.962.962 0 0 1 0 1.924z",
    className: "cls-1",
    transform: "translate(-166.71 -154.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M16.438 27.947L4.5 26.592a1.639 1.639 0 0 0-1.29.372 1.661 1.661 0 0 0-.63 1.136l-.219 1.792h-.677A1.757 1.757 0 0 0 0 31.707v8.94a1.661 1.661 0 0 0 1.617 1.7h12.067a1.794 1.794 0 0 0 1.836-1.7V40.3a2.186 2.186 0 0 0 .831-.35 1.814 1.814 0 0 0 .634-1.18l1.005-8.874a1.771 1.771 0 0 0-1.552-1.949zm-1.792 12.7a.92.92 0 0 1-.962.831h-12a.787.787 0 0 1-.81-.763v-1.686l3.388-2.492a1.049 1.049 0 0 1 1.355.066L8 38.7a2.055 2.055 0 0 0 1.29.481 1.989 1.989 0 0 0 1.049-.284l4.306-2.492v4.24zm0-5.268L9.88 38.155a1.115 1.115 0 0 1-1.29-.109l-2.4-2.12a1.945 1.945 0 0 0-2.426-.087l-2.885 2.1v-6.23a.882.882 0 0 1 .809-.94h12a1 1 0 0 1 .962.94v3.672zm2.471-5.6v.009l-1.027 8.874a.743.743 0 0 1-.284.59c-.087.087-.284.131-.284.175v-7.72a1.88 1.88 0 0 0-1.836-1.814H3.236l.2-1.7a1.006 1.006 0 0 1 .328-.568 1 1 0 0 1 .656-.175l11.913 1.377a.874.874 0 0 1 .783.948z",
    className: "cls-1",
    transform: "translate(0 -26.576)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGallery, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gallery.e4dfb42e.svg";
export { ForwardRef as ReactComponent };